import { useMutation } from "@apollo/client";
import { useContext, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { DELETE_EDUCATION_LEVEL } from "../../../Schema/EducationLevel";

export const useDeleteEducationLevel = ({ handleClose, setRefetch }) => {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteEducationLevel] = useMutation(DELETE_EDUCATION_LEVEL, {
    onCompleted: ({ deleteEducationLevel }) => {
      setLoading(false);
      if (deleteEducationLevel?.isSuccess === true) {
        setAlert(true, "success", deleteEducationLevel?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteEducationLevel?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = (id) => {
    deleteEducationLevel({
      variables: {
        id: id,
      },
    });
  };

  return { handleDelete, loading };
};
